var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{staticClass:"din-corridor",style:(_vm.corridorCSSStyle),attrs:{"d":_vm.corridorSVGPath}}),_c('path',{staticClass:"din-target",style:(_vm.targetCSSStyle),attrs:{"d":_vm.targetSVGPath}})])}
var staticRenderFns = []

export { render, staticRenderFns }